/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  isComplete?: boolean;
}

function RhombusIcon(props: IProps) {
  const { width = 32, height = 32, isComplete = false, ...rest } = props;

  return isComplete ? (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <rect x="-0.970581" y="15.9706" width="24" height="24" rx="4" transform="rotate(-45 -0.970581 15.9706)" fill="#D9B244" />
      <path d="M11 16.5L14 19.5L21.5 12" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <rect
        x="-0.970581"
        y="15.9706"
        width="24"
        height="24"
        rx="4"
        transform="rotate(-45 -0.970581 15.9706)"
        fill="#9193AA"
        fillOpacity="0.2"
      />
    </svg>
  );
}

export default RhombusIcon;
